
































import Vue from "vue";
import { WorkRecordServiceProxy,WorkRecordSettingServiceProxy } from "@/service-proxies/app-v2/work-record.service-proxies";
const workRecordService = new WorkRecordServiceProxy();
const workRecordSettingServiceProxy = new WorkRecordSettingServiceProxy();

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      taskId: "",
      workRecordId: "",
      customerId: "",
      processProgress: "",
      form: {
        checkedList: [],
        comments: ''
      },
      userOptions: [],
      backComment: '',
    };
  },
  methods: {
    initData(record) {
      this.taskId = record.currentTaskId;
      this.workRecordId = record.id;
      this.customerId = record.customerId;
      this.processProgress = record.processProgress;
      this.form.comments = record.comments;
      workRecordSettingServiceProxy.getProcessUsers(this.workRecordId).then(res=>{
        this.userOptions = res.users.map((item) => {
          return { label: item.name, value: item.id };
        });
        // 默认选择指派人员
        this.form.checkedList = res.assignedUsers;
      });
       this.backComment = '';
      workRecordService.getWorkRecordProcessCommentInfo(record.id).then(res=>{
        this.backComment = res?.backComment || '';
      })
      
    },
    save() {
      if (this.form.checkedList.length > 0) {
        const params: any = {
          comments: this.form.comments,
          processProgress: this.processProgress,
          processUserIds: this.form.checkedList,
          taskId: this.taskId,
          workRecordId: this.workRecordId,
        };

        workRecordService.processWorkRecord(params).then((res) => {
          this.form.checkedList = [];
          this.$message.success(this.$t("success"));
          this.$emit("cancel", true);
        });
      }
    },
  },
});
